import React, { useEffect, useState } from "react";
import ChatUI from "../chat";
import Lottie from "react-lottie-player";
import chatbot from "../assest/chatbot.json";
import chatbotClose from "../assest/close.json";
import { useLocation } from "react-router-dom";
function BubbleLayout() {
  const [play, setPlay] = useState(true);
  const [showChat, setShowChat] = useState(false);
  const [parentUrl, setParentUrl] = useState("");
  useEffect(() => {
    setPlay(true);
    const timeout = setTimeout(
      () => {
        setPlay(false);
      },
      showChat ? 600 : 1500
    );

    return () => clearTimeout(timeout);
  }, [showChat]);

   useEffect(() => {
    const TIMER_KEY = "introductionTimer";
    const INTRO_DURATION = 120000; // 2 minutes

    const startTimer = () => {
      const currentTime = Date.now();
      localStorage.setItem(TIMER_KEY, currentTime.toString());
      setTimeout(() => {
        setShowIntroduction(true);
        localStorage.removeItem(TIMER_KEY); // Clean up after showing the introduction
      }, INTRO_DURATION);
    };

    const storedTime = localStorage.getItem(TIMER_KEY);

    if (storedTime) {
      const elapsed = Date.now() - parseInt(storedTime);
      if (elapsed >= INTRO_DURATION) {
        setShowIntroduction(true); 
        localStorage.removeItem(TIMER_KEY);
        startTimer();
      } else {
        const remainingTime = INTRO_DURATION - elapsed;
        setTimeout(() => {
          setShowIntroduction(true);
          localStorage.removeItem(TIMER_KEY);
        }, remainingTime);
      }
    } else {
      
      startTimer();
    }

  }, []);

  useEffect(() => {
    const handleMessage = (event: {
      data: { type: string; url: React.SetStateAction<string> };
    }) => {
      if (event.data.type === "parent-url") {
        setParentUrl(event.data.url); // Set the parent URL
        console.log("Parent URL:", event.data.url);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const [showIntroduction, setShowIntroduction] = useState(false);
  useEffect(() => {
    const message = {
      type: "chat-widget-resize",
      state: showChat ? "Chat" : showIntroduction ? "Introduction" : "Closed",
      element: "chat-widget",
    };
    window.parent.postMessage(message, "*");
  }, [showChat, showIntroduction]);

  return (
    <div className="fixed bottom-[0px] translate-x-0 transition-transform duration-300 right-[0px] z-30">
      {showIntroduction && (
        <div className="relative mb-2">
          <div className="text-sm text-gray-600 flex flex-col gap-2 ">
            <button
              className="ml-auto p-1 shadow-md rounded-lg  text-gray-500 hover:text-gray-800 bg-slate-50"
              onClick={() => setShowIntroduction(false)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <p className="font-semibold  px-3 ml-auto p-2 shadow-md rounded-lg bg-slate-50">
              Bonjour, je suis Continuum
            </p>
            <p className="ml-auto  px-3 p-2 shadow-md rounded-lg bg-slate-50">
              Comment puis-je vous aider ?
            </p>
          </div>
        </div>
      )}
      <div
        className={`relative rounded-full cursor-pointer w-[4.3rem] ml-auto h-[4.3rem] bg-blue-500 shadow-sm border border-zinc-200  ${
          showChat ? "" : "p-2"
        }`}
      >
        {showChat ? (
          <Lottie
            animationData={chatbotClose}
            style={{ height: "65px", width: "65px" }}
            play={play}
            onClick={() => setShowChat(!showChat)}
            className=" mr-0.5  invert"
          />
        ) : (
          <Lottie
            animationData={chatbot}
            style={{ height: "50px", width: "50px" }}
            play={play}
            onClick={() => setShowChat(!showChat)}
            className="brightness-0 invert"
          />
        )}
      </div>
      <div
        className={`absolute bottom-20 right-0 h-[400px] w-[350px] shadow-xl rounded-lg duration-300 transition-transform ${
          showChat ? "translate-y-2 scale-100" : "translate-y-[130%] scale-0"
        }`}
      >
        <ChatUI isBubble={true} parentUrl={parentUrl} />
      </div>
    </div>
  );
}

export default BubbleLayout;
